import React, { useRef } from "react";

import Button from "./Button";
import rawColors from "./colors";
import { PagesEnum, cellData } from "./utils";

function SingleCell({ cell, setPage, setColors, colors, resetColors }) {
  const canvasEl = useRef(null);
  const cellInfo = cellData[cell];

  const changeLayerColor = (layerNumber) => {
    const tempLayerColors = { ...colors };
    tempLayerColors[layerNumber] =
      rawColors[Math.floor(Math.random() * rawColors.length)];
    setColors(tempLayerColors);
  };

  const changeAllColors = () => {
    const tempLayerColors = { ...colors };
    const tempColors = [...rawColors];
    for (let i = 1; i <= cellInfo.layers.length; i++) {
      const usedColorIndex = Math.floor(Math.random() * tempColors.length);
      const usedColor = tempColors.splice(usedColorIndex, 1);
      tempLayerColors[i] = usedColor.pop();
    }
    setColors(tempLayerColors);
  };

  return (
    <div className="single-cell">
      <div className="cell-editor">
        <h3 className="upper-label">CLICK TO ADD COLOR</h3>
        <ul className="layer-list">
          {cellInfo.layers.map((layerNum) => (
            <li
              key={`layer-${layerNum}`}
              onClick={() => {
                changeLayerColor(layerNum);
              }}
            >
              {React.createElement(cellInfo.navElement, {
                isolatedLayer: layerNum,
              })}
            </li>
          ))}
        </ul>
        <h3 className="lower-label">CLICK TO CHANGE ALL THE COLORS</h3>
        <div className="all-layer" onClick={changeAllColors}>
          {React.createElement(cellInfo.navElement, {
            allLayerFocus: true,
          })}
        </div>
        <div className="canvas">
          {React.createElement(cellInfo.element, {
            layerColors: colors,
            ref: canvasEl,
          })}
        </div>
        <div className="editor-buttons">
          <Button
            onClick={() => {
              resetColors(cell);
            }}
            label="Clear"
          />
          <Button onClick={() => setPage(PagesEnum.GRID)} label="Back" />
        </div>

        <div className="sign-button">
          <Button
            onClick={() => {
              setPage(PagesEnum.PRINT);
            }}
            label="Sign and Print"
          />
        </div>
      </div>
    </div>
  );
}

export default SingleCell;
